import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/digital-printing',
    name: 'DigitalPrinting',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/digital-printing/logo-identify-task/list',
    meta: {
      title: '数码印花'
    },
    children: [
      {
        path: 'logo-identify-task/list',
        name: 'DigitalPrintingLogoIdentifyTaskList',
        component: () => import('./logo-identify-task/views/list/index.vue'),
        meta: {
          title: '图案识别任务',
          auth: true,
        },
      },
      {
        path: 'logo-extraction-record/list',
        name: 'DigitalPrintingLogoExtractionRecordList',
        component: () => import('./logo-extraction-record/views/list/index.vue'),
        meta: {
          title: '图案提取纪录',
          auth: true,
        },
      },
      {
        path: 'logo-handle-task/list',
        name: 'DigitalPrintingLogoHandleTaskList',
        component: () => import('./logo-handle-task/views/list/index.vue'),
        meta: {
          title: '图案处理任务',
          auth: true,
        },
      },
      {
        path: 'production-picture/list',
        name: 'DigitalPrintingProductionPictureList',
        component: () => import('./production-picture/views/list/index.vue'),
        meta: {
          title: '生产图列表',
          auth: true,
        },
      },
      {
        path: 'texture-batch-task/list',
        name: 'InspirationCenterTextureBatchTaskList',
        component: () => import('./texture-batch-task/views/list/index.vue'),
        meta: {
          title: '贴图批次任务',
          auth: true,
        },
      },

    ]
  }
] as IRouteConfig[];
